import { render } from "./Study.vue?vue&type=template&id=5c0727ab"
import script from "./Study.vue?vue&type=script&lang=ts"
export * from "./Study.vue?vue&type=script&lang=ts"
script.render = render

export default script